import { render, staticRenderFns } from "./AccountTypesViewPermissions.vue?vue&type=template&id=744ee01c&lang=pug&"
import script from "./AccountTypesViewPermissions.vue?vue&type=script&lang=js&"
export * from "./AccountTypesViewPermissions.vue?vue&type=script&lang=js&"
import style0 from "./AccountTypesViewPermissions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports